/*
 * Krudo blocking mode-picker modal.
 * Shows on every page until the visitor has chosen a shopping mode.
 * Once chosen, the choice lives in cart.attributes.mode (server-side, read by Liquid)
 * with a cookie mirror (krudo_mode_picked=1) so we can skip the modal cheaply on subsequent loads.
 */
class ModePicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll("[data-mode-choice]");
    this.buttons.forEach((btn) => {
      btn.addEventListener("click", this.onPick.bind(this));
    });

    // In the Theme Editor, only open if the section settings asked for it
    // (so merchants can edit the page without the modal in the way).
    if (window.Shopify && Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.open();
      return;
    }

    if (!window.KrudoMode || !window.KrudoMode.hasPicked()) {
      this.open();
    }
  }

  open() {
    this.setAttribute("open", "");
    document.body.classList.add("mode-picker-is-open");
    // Focus the first choice for keyboard users.
    requestAnimationFrame(() => {
      const first = this.querySelector("[data-mode-choice]");
      if (first) first.focus();
    });
  }

  close() {
    this.removeAttribute("open");
    document.body.classList.remove("mode-picker-is-open");
  }

  async onPick(e) {
    const btn = e.currentTarget;
    const mode = btn.dataset.modeChoice;
    if (!mode || !window.KrudoMode) return;

    btn.setAttribute("disabled", "");
    btn.classList.add("is-loading");
    try {
      // Cart is empty on a first-time visit, so no confirm flow needed —
      // we go straight to set(). switchWithConfirm() handles the cart-has-items case
      // and is what the header pill / PDP off-mode panel call instead.
      await window.KrudoMode.set(mode);
    } catch (err) {
      btn.removeAttribute("disabled");
      btn.classList.remove("is-loading");
      console.error("[mode-picker] failed to set mode", err);
    }
  }
}

customElements.define("mode-picker", ModePicker);
